<!-- =========================================================================================
    File Name: VxSidebarItem.vue
    Description: Sidebar item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VxSidebarItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div :class="[
    { 'vs-sidebar-item-active': activeLink },
    { 'disabled-item pointer-events-none': isDisabled },
  ]" class="vs-sidebar--item" v-if="canSee && shouldShowInCurrentFormFactor() && guestUserCheck()">
    <router-link v-if="to && !IsAbsolute" :to="to" :target="target" exact :class="[{ 'router-link-active': activeLink }]">
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
      <feather-icon :icon="icon" :class="{ 'w-3 h-3': iconSmall }" v-else />
      <slot></slot>
    </router-link>

    <a v-else :href="href || to" :target="target">
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
      <feather-icon :icon="icon" :class="{ 'w-3 h-3': iconSmall }" v-else />
      <slot></slot>
    </a>
    <span :id="slug"></span>
  </div>
</template>

<script>
export default {
  name: "VxSidebarItem",
  props: {
    IsVisualStudio: {

    },
    slug: {
      default: "",
      type: String
    },
    icon: {
      default: "",
      type: String,
    },
    iconSmall: {
      default: false,
      type: Boolean,
    },
    iconPack: {
      default: "material-icons",
      type: String,
    },
    href: {
      default: "#",
      type: String,
    },
    to: {
      default: null,
      type: String,
    },
    index: {
      default: null,
      type: [String, Number],
    },
    featherIcon: {
      default: true,
      type: Boolean,
    },
    target: {
      default: "_self",
      type: String,
    },
    isDisabled: {
      default: false,
      type: Boolean,
    },
    ShowForGuestUser: {
      default: false,
      type: Boolean,
    },
    IsAbsolute: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      activeLink: false,
    };
  },
  watch: {
    $route() {
      this.CheckIsActive();
    },
  },
  methods: {
    CheckIsActive() {
      if (this.to) {
        if (this.to == this.$router.path && this.to) this.activeLink = true;
        else this.activeLink = false;
      }
    },
    shouldShowInCurrentFormFactor() {
      if (
        this.$props.IsVisualStudio &&
        this.$store.state.IsVisualStudio
      ) {
        return false;
      }
      return true;
    },
    guestUserCheck() {
      return (this.$store.state.IsGuestUser && this.ShowForGuestUser) || !this.$store.state.IsGuestUser;
    }
  },
  computed: {
    canSee() {
      this.$acl.check(this.$store.state.userRole);
      if (this.to) {
        return this.$acl.check(this.$router.match(this.to).meta.rule);
      }
      return true;
    },
  },
  updated() {
    this.CheckIsActive();
  },
};
</script>
